import { AppID } from "@ikonintegration/idmclient";
//
import APIRequest from "./core/Request";
// API Compoenents
import OperationCategory from "./operations/Category";
import OperationProduct from "./operations/Product";
import OperationLicense from "./operations/License";
import OperationLicenseConsumption from "./operations/LicenseConsumption";
import OperationOrder from "./operations/Order";
import OperationProductOrder from "./operations/ProductOrder";
import OperationVoucher from "./operations/Voucher";
import OperationKey from "./operations/Key";
import OperationVault from "./operations/Vault";
//
export default class Client {
  /* config structure
    {
      endpoint: 'https://localhost',
      port: 9998,
      apiKey: '',
      tenantID: '',
      authorizationToken: '' -- optional
    }
  */
  constructor(config) {
    this.config = config;
    // api operations
    this.category = new OperationCategory(this);
    this.license = new OperationLicense(this);
    this.licenseConsumption = new OperationLicenseConsumption(this);
    this.product = new OperationProduct(this);
    this.productOrder = new OperationProductOrder(this);
    this.order = new OperationOrder(this);
    this.voucher = new OperationVoucher(this);
    this.key = new OperationKey(this);
    this.vault = new OperationVault(this);
  }

  async newBaseRequest(method) {
    const req = new APIRequest(method);
    //Auth
    if (this.config.apiKey) {
      const iToken = new AppID(null, this.config.apiKey, this.config.apiKey);
      req.appendHeader("API-Key", iToken.getHash());
    }
    if (this.config.authorizationToken) {
      let token = this.config.authorizationToken;
      if (typeof this.config.authorizationToken === "function") {
        token = await this.config.authorizationToken();
      }
      req.appendHeader("Authorization", token);
    }
    if (this.config.tenantID) req.appendHeader("tenantID", this.config.tenantID);
    //
    req.baseURL = this.config.endpoint;
    if (this.config.port) req.baseURL += `:${this.config.port}`;
    //
    return req;
  }
}
